import { render, staticRenderFns } from "./receiptPreview.vue?vue&type=template&id=feaab51e&scoped=true&"
import script from "./receiptPreview.vue?vue&type=script&lang=js&"
export * from "./receiptPreview.vue?vue&type=script&lang=js&"
import style0 from "./receiptPreview.vue?vue&type=style&index=0&id=feaab51e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feaab51e",
  null
  
)

export default component.exports